import { IDataMap } from '../../interfaces';

export class DataMap<T> implements IDataMap<T> {
	map: KnockoutComputed<T[]>;
	data: KnockoutObservable<T[]>;
	constructor(
		data: KnockoutObservableArray<T> | KnockoutComputed<T[]> | KnockoutObservable<T[]> | DataMap<T>
	) {
		if (data instanceof DataMap) {
			this.data = data.map;
		} else {
			this.data = <KnockoutObservable<T[]>>data;
		}
	}
}
